import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers/internalApi";
import type { Post } from "@/react/types/Post";
import { Typography } from "@circle-react-uikit/Typography";

export interface HistoryDetailViewReportedPostProps {
  log: {
    message: {
      response_details: {
        body: {
          id: number;
          space_slug: string;
          post_slug: string;
        };
      };
    };
  };
}

export const HistoryDetailViewReportedPost = ({
  log,
}: HistoryDetailViewReportedPostProps) => {
  const { space_slug: spaceSlug, post_slug: postSlug } =
    log.message.response_details?.body ?? {};

  const { data: post, isLoading } = useQuery<Post>({
    queryKey: ["posts", log.message.response_details?.body?.id ?? null],
    queryFn: () =>
      reactQueryGet(
        internalApi.posts.show({
          postSlug,
          spaceSlug,
        }),
      ),
    retry: false,
  });

  return (
    <div className="flex flex-col gap-2">
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.ai_agents.post")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          {post ? (
            <a
              href={`/c/${spaceSlug}/${postSlug}`}
              target="_blank"
              className="text-sm"
              rel="noopener noreferrer"
            >
              {t("settings.workflows.action_messages.ai_agents.post_link")}
            </a>
          ) : (
            <Typography.LabelSm>
              {t(
                `settings.workflows.action_messages.ai_agents.${isLoading ? "post_loading" : "post_not_found"}`,
              )}
            </Typography.LabelSm>
          )}
        </div>
      </div>
    </div>
  );
};
